/* Keep delivery information compact, with hover, tap and keyboard disclosure. */
(() => {
  if (customElements.get('wolf-cart-mto-notice')) return;

  class WolfCartMtoNotice extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-wolf-mto-toggle]');
      this.content = this.querySelector('[data-wolf-mto-content]');
      if (!this.toggle || !this.content) return;
      this.compact = true;
      this.toggleAttribute('data-compact', true);
      this.toggle.hidden = false;
      this.toggle.disabled = false;
      this.setExpanded(false);

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.hovered = false;
      this.manualOpen = false;
      let pointerDownInside = false;
      this.addEventListener('pointerdown', (event) => {
        pointerDownInside = true;
        // Touch can follow mouse hover on the same device without mouseleave.
        if (event.pointerType !== 'mouse') this.hovered = false;
      }, options);
      this.addEventListener('pointercancel', () => { pointerDownInside = false; }, options);
      this.addEventListener('click', () => { pointerDownInside = false; }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        this.hovered = true;
        this.setExpanded(true);
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        pointerDownInside = false;
        // A keyboard user can keep reading while focus remains on the control.
        this.manualOpen = this.expanded && this.toggle.matches(':focus-visible');
        this.setExpanded(this.manualOpen);
      }, options);
      this.toggle.addEventListener('click', (event) => {
        // Mouse hover already reveals the copy. Touch and keyboard toggle it.
        if (event.detail > 0 && this.hovered) return;
        this.manualOpen = !this.expanded;
        this.setExpanded(this.manualOpen);
      }, options);
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        if (event.relatedTarget === null && pointerDownInside) return;
        pointerDownInside = false;
        this.manualOpen = false;
        this.setExpanded(this.hovered);
      }, options);
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !this.compact || !this.expanded) return;
        event.stopPropagation();
        this.manualOpen = false;
        this.hovered = false;
        this.setExpanded(false);
      }, options);
    }

    setExpanded(expanded) {
      this.expanded = this.compact && Boolean(expanded);
      this.toggleAttribute('data-expanded', this.expanded);
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      const concealed = this.compact && !this.expanded;
      this.content.setAttribute('aria-hidden', String(concealed));
      this.content.inert = concealed;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.compact = undefined;
    }
  }

  customElements.define('wolf-cart-mto-notice', WolfCartMtoNotice);
})();
